import { Box } from "@mui/material";
import { Circle, GoogleMap, useLoadScript } from "@react-google-maps/api";
import { useMap } from "../../context/GoogleMapsApiKeyContext";

import Loading from "../Loading";
import Marker from "./Marker";
import SearchPlacesInput from "./SearchPlacesInput";
type googleType = { googleMapsApiKey: any };

type IMapWrapperProps = {
  center: any;
  zoom: any;
  markers: any[];
  setCenter?: any;
  setZoom?: any;
  draggable?: boolean;
  handleMarker?: any;
  handleSearch?: any;
  InfoComponent?: any;
  sx?: any;
};

type IProps = IMapWrapperProps & {
  googleMapsApiKey: string
};

const libraries = ["places"];

const Map: React.FC<IProps> = ({
  center,
  zoom,
  markers,
  setCenter,
  setZoom,
  draggable = true,
  handleMarker = () => {},
  handleSearch = () => {},
  InfoComponent,
  sx,
  googleMapsApiKey
}) => {
  const { isLoaded } = useLoadScript({
    id: "google-map-script",
    googleMapsApiKey: googleMapsApiKey,
    libraries,
  } as googleType);

  return (
    <>
      {!isLoaded ? (
        <Loading />
      ) : (
        <>
          {handleSearch && setZoom && setCenter && (
            <SearchPlacesInput
              setCenter={setCenter}
              setZoom={setZoom}
              onSelect={handleSearch}
              sx={{ mb: 2 }}
            />
          )}
          <Box sx={sx}>
            <GoogleMap
              zoom={zoom}
              center={center}
              mapContainerClassName="map-container"
              onClick={handleMarker}
            >
              {markers.map((marker: any, index: any) => (
                <Box key={index}>
                  <Marker
                    position={marker.pos}
                    icon={marker.icon}
                    info={marker.info}
                    draggable={draggable}
                    handleMarker={handleMarker}
                    InfoComponent={InfoComponent}
                  />
                  <Circle center={marker.pos} />
                </Box>
              ))}
            </GoogleMap>
          </Box>
        </>
      )}
    </>
  );
};

const MapWrapper: React.FC<IMapWrapperProps> = (props) => {
  const { googleMapsApiKey, loading, error } = useMap();


  if (loading) {
    return  <Loading />;
  }

  if (error || !googleMapsApiKey) {
    return  null;
  }

  return <Map {...props} googleMapsApiKey={googleMapsApiKey} />
};

export default MapWrapper;
